module.exports = __webpack_public_path__ + "assets/88e1555dd9f324a24de8111b5cf43178.png";